import { useCallback } from 'react';
import { selectUser } from 'reducers/selectors';
import { useAppStore } from 'store/hooks';
const useNavigateToStartOnboardingFlow = (navigation) => {
    const store = useAppStore();
    const startFlow = useCallback(() => {
        const user = selectUser(store.getState());
        if ((user.kycStartedAt || user.creditScoreIdentityLockedAt) &&
            user.dateOfBirth) {
            navigation.navigateDeprecated('RentReportingOnboardingSelectAddress');
        }
        else {
            navigation.navigateDeprecated('RentReportingOnboardingPersonalDetails');
        }
    }, []);
    return startFlow;
};
export default useNavigateToStartOnboardingFlow;
